import PropTypes from 'prop-types';

const profileTabsPropertyTypes = {
  coursesConnection: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  }).isRequired,
  brands: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired).isRequired,
};

export default profileTabsPropertyTypes;
